import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { RoutingService } from '../routing.service';
import { FeatureManagerService } from '@Services/global';
import { FeatureToggle } from '@Enums';

@Injectable()
export class RedirectGuard implements CanActivateChild {

    constructor(
    private readonly featureManagerService: FeatureManagerService,
    private readonly routingService: RoutingService
    ) { }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let redirectTo = localStorage.getItem('uwpipeline.redirectTo');

        if (redirectTo) {
            localStorage.removeItem('uwpipeline.redirectTo');
            this.routingService.navigateToUrl(redirectTo);
        }

        const enableDeepLinking = this.featureManagerService.getByName(FeatureToggle.GlobalRoutingDeepLinking).enabled;
        
        if (enableDeepLinking) {

            redirectTo = localStorage.getItem('uwpipeline.savedRedirectTo');

            if (redirectTo) {
                localStorage.removeItem('uwpipeline.savedRedirectTo');
                this.routingService.navigateToUrl(redirectTo);
            }
        }
        
        return true;
    }


}
